import React, {Fragment} from 'react';

import {ContactDataList} from 'presentation/pages/public/sign-up/components/ContactDataList';
import {Step3Form} from 'presentation/pages/public/sign-up/components/Forms';
import {useSignUpFormDataStore} from '../../../store/useSignUpFormDataStore';

export function Step3() {
	const signUpFormData = useSignUpFormDataStore(state => state.signUpFormData);
	const {dsEmailLogin, celular} = signUpFormData;

	return (
		<Fragment>
			<ContactDataList email={dsEmailLogin} phoneNumber={celular} />
			<Step3Form />
		</Fragment>
	);
}
